import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { ApiError } from '../../../core/models/common/api-error';
import { Store } from '@ngrx/store';
import { authActions } from '../../../core/store/auth';

@Component({
  selector: 'app-register-form',
  template: `
    <form (ngSubmit)="submit()">
      <div class="grid md:grid-cols-2 md:gap-6">
        <app-text-input
          [control]="form.get('first_name')"
          label="Prénom"
          name="first_name"
        ></app-text-input>
        <app-text-input
          [control]="form.get('last_name')"
          label="Nom"
          name="last_name"
        ></app-text-input>
      </div>
      <app-text-input
        [disabled]="!!email"
        [control]="form.get('email')"
        label="Adresse e-mail"
        name="email"
      ></app-text-input>
      <app-password-input
        [control]="form.get('password')"
        label="Créez votre mot de passe"
        name="password"
      ></app-password-input>

      <div class="pt-4 text-center md:pt-8">
        <app-button
          type="submit"
          icon="arrow-right-to-bracket"
          [loading]="sendingData"
        >
          {{ buttonText }}
        </app-button>
      </div>
    </form>
  `,
  standalone: false,
})
export class RegisterFormComponent implements OnInit {
  @Input() first_name: string | null;
  @Input() last_name: string | null;
  @Input() email: string | null;
  @Input() buttonText = "S'inscrire";
  @Input() inviteId: number;
  @Output() afterRegister = new EventEmitter<void>();
  form: UntypedFormGroup;
  sendingData = false;

  constructor(
    private authService: AuthService,
    private formValidationService: FormValidationService,
    private store: Store,
  ) {}

  ngOnInit() {
    this.form = new UntypedFormGroup({
      first_name: new UntypedFormControl(this.first_name ?? '', [
        Validators.required,
      ]),
      last_name: new UntypedFormControl(this.last_name ?? '', [
        Validators.required,
      ]),
      email: new UntypedFormControl(this.email ?? '', [Validators.required]),
      password: new UntypedFormControl('', [Validators.required]),
    });
  }

  async submit() {
    if (this.formValidationService.validate(this.form)) {
      this.sendingData = true;
      try {
        const response = await this.authService.register({
          ...this.form.value,
          invite_id: this.inviteId,
        });
        this.store.dispatch(
          authActions.loginSuccess({
            user: response.user,
            token: response.token,
          }),
        );
        this.afterRegister.emit();
      } catch (exception) {
        this.formValidationService.displayApiValidationErrors(
          this.form,
          exception as ApiError,
        );
      }
      this.sendingData = false;
    }
  }
}
